import Tooltip from "rc-tooltip";
import React from "react";
import { useIntl } from "react-intl";

import Img from "@components/FileServer/Img";

type Message = {
  id: string;
  defaultMessage: string;
};

type Props = {
  sizeClass?: string | any;
  privateFareMsg: Message;
  acceptableFare: Message;
};

export const PrivateFareIndicator = ({
  sizeClass,
  privateFareMsg,
  acceptableFare,
}: Props) => {
  const intl = useIntl();

  return (
    <Tooltip
      overlay={intl.formatMessage(privateFareMsg)}
      trigger={["hover", "click"]}
      mouseEnterDelay={0.5}
      mouseLeaveDelay={0.2}
    >
      <div>
        <Img
          src="/static/images/cbt-private-fare.svg"
          className={`travel-policy-icon acceptable-fare ${sizeClass}`}
          alt={intl.formatMessage(acceptableFare)}
        />
      </div>
    </Tooltip>
  );
};
